"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BaseButton = require("./BaseButton");
var _colorHelpers = require("./colorHelpers");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var RoundButton = (0, _styledComponents.default)(_BaseButton.BaseButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  border-radius: 50%;\n  height: 53px;\n  width: 53px;\n\n  &:not(:disabled):not(.disabled):hover {\n    color: ", ";\n    background-color: ", ";\n    border-color: transparent;\n    box-shadow: ", ";\n  }\n\n  &:focus,\n  &:not(:disabled):not(.disabled):active {\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  svg {\n    margin: 0;\n    path {\n      ", "\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryShade;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.tertiary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.lightPrimary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return "0 4px 5px ".concat(theme.colors.tertiary, "1a");
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.tertiary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.secondaryShade;
}, function (_ref8) {
  var theme = _ref8.theme;
  return (0, _colorHelpers.buttonAccentColors)(theme.colors).accentBorder;
}, function (_ref9) {
  var loading = _ref9.loading;
  return loading && 'fill: initial;';
});
exports.RoundButton = RoundButton;